export const PATH_URL = {
  HOME: '/',
  ABOUT: '/about',
  INFO: '/info',
  WELCOME: '/welcome',
  SITEMAP: '/sitemap.xml',
};
